<template>
    <product title="Farligt gods / ADR">
        <div slot="description">
            <p>
                P. Pedersen & Søn transporterer ilt og gas, fyrværkeri, cellulosefortynder, silikonefjerner, acetone,<br>malerrelaterede varer samt spild etc.
            </p>
            <p>
                P. Pedersen & Søn er certificeret til at håndtere farligt gods (ADR)
            </p>
            <p>
                <div class="btn-holder alt">
                    <a href="/static/images/pp_farligtgods_certifikat.png"
                        rel="noopener"
                        target="_blank"
                        class="btn-primary text-center text-uppercase active md-round">
                        <i class="fa fa-file-o fa-fw"></i> Se certifikat
                    </a>
                    Certifikatet kan også findes på Energistyrelsens hjemmeside. <!--<a rel="noopener" target="_blank" href="https://affaldsregister.ens.dk/Default.aspx">her</a>.-->
                </div>
            </p>
            <p>
                <img style="width:calc(50% - 10px);float:left;margin-right:10px;" class="product-image" src="/static/images/farligt_gods.jpg" />
                <img style="width:calc(50% - 10px);float:left;margin-left:10px;" class="product-image" src="/static/images/farligt_gods_2.jpg" />
            </p>
        </div>
    </product>
</template>
<script>
    import Product from '../../../components/elements/product'
    export default {
        name: 'Farligt Gods',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// farligtgods.vue?688e9667